import {
  createResetableStore,
  preventMultipleActionDispatch,
} from "~/utils/store";
import { getInvestorSSNType, userHasAccounts } from "~/lib/hostAppData";

export default createResetableStore({
  namespaced: true,
  state() {
    return {
      customerNameData: null,
    };
  },
  getters: {
    customerName(state) {
      return state.customerNameData;
    },
    customerFullName(state, getters, rootState, rootGetters) {
      const investorIsSSN = getInvestorSSNType() == "SSN";
      const { firstName, middleInitial, lastName } = getters.customerName || {};

      return ((
        rootGetters["userProfileDetails/isOperator"]
          ? investorIsSSN
          : userHasAccounts().taAccounts
          ? investorIsSSN
          : userHasAccounts().tracAccounts
      )
        ? `${firstName ?? ""} ${middleInitial ?? ""} ${lastName ?? ""}`
        : lastName ?? ""
      ).trim();
    },
  },
  mutations: {
    setCustomerNameData(state, customerNameData) {
      state.customerNameData = customerNameData;
    },
  },
  actions: {
    fetchData: preventMultipleActionDispatch(async function (
      { commit },
      { dataloader }
    ) {
      commit("setCustomerNameData", await dataloader.getCustomerName());
    }),
  },
});
